import React from 'react';

import FiltersSelectContent from '../FiltersSelectContent';
import { TYPE } from './FilterMessagePartialsType.constants';

interface FilterMessagePartialsTypeProps {
  type?: string;
}

export const FilterMessagePartialsType: React.FC<FilterMessagePartialsTypeProps> = ({
  type = 'messagePartialsType',
}) => <FiltersSelectContent type={type} items={TYPE} />;
